import axiosClient from ".";
class BetAPI {
  static createBet(data) {
    return axiosClient.post("/bets.json", data);
  }
  static updatebet(data) {
    return axiosClient.put(`/bets/update.json`, data);
  }
  static getAllBets() {
    return axiosClient.get("/bets.json");
  }
  static deleteAllBets() {
    return axiosClient.delete("/bets.json");
  }
  static seedBetData() {
    return axiosClient.get("/bets/seed_bet_data.json");
  }
}
export default BetAPI;
